import React, { useEffect, useState } from 'react';
import { Slider, Button, Input, Select, TextArea, Toast } from '@kaleyra/emmy';
import { useTranslation } from "react-i18next";
import { isEmpty } from 'lodash';
import Styles from './index.module.scss';
import { getcharcount, validateOnlyNumbers, validateURL } from '../../../../../../utils';

type SenderIdPropType = {
}

type OptionType = {
    key: string;
    value: string;
}

export type MapStateType = {
    templateViewDetails: any;
    params: any;
    data: any;
};

export type DispatchPropsType = {
    onClose: () => void;
    onSave: (editTemplateData: any, callback: (resp: any, flag: boolean) => void) => void;
    onShortenUrl: (urlOb: any, callback: (resp: any, flag: boolean) => void) => void;
    onLoad: () => void;
    onFileShortener: (payload: any, callback: (resp: any, flag: boolean) => void) => void;
};

const TemplateEditForm: React.FC<SenderIdPropType & DispatchPropsType & MapStateType> = ({
    onClose, onSave, onShortenUrl, onLoad, templateViewDetails, params, data, onFileShortener
}) => {

    const { t } = useTranslation();

    const [showSideModal, setShowSideModal] = useState(false);
    const [title, setTitle] = useState('');
    const [templateId, setTemplateId] = useState('');
    const [purpose, setPurpose] = useState<any>(undefined);
    const [senderId, setSenderId] = useState<any>(undefined);
    const [textContent, setTextContent] = useState('');
    const [urlShortenerText, setUrlShortenerText] = useState('');
    // const [shortenedUrl, setShortenedUrl] = useState('');
    const [textareaCharCount, setTextareaCharCount] = useState<number>(0);
    const [messageUnitsCount, setMessageUnitsCount] = useState<number>(1);

    const isIndiaUser = (data.smsTemplatesData.is_India).toString() === "1";

    useEffect(() => {
        const { title, template_id, sender_id, purpose, content } = templateViewDetails.templates[0];
        setTitle(title);
        setTemplateId(template_id || '');
        setPurpose(purpose);
        setSenderId(sender_id);
        setTextContent(content);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(()=>{
        const { count, units } = getcharcount(textContent);
        setTextareaCharCount(count);
        setMessageUnitsCount(units);
    },[textContent])

    const getMainFooter = (): React.ReactNode => {
        return (
            <div className={Styles.flexEnd}>
                <Button type="tertiary" onClick={onClose}>
                    {t('mainCancel')}
                </Button>
                <Button type="primary" onClick={() => handleTemplateEdit()}>
                    {t('mainSave')}
                </Button>
            </div>
        );
    };

    const templateIdStatus = (): "default" | "error" => {
        return (templateId === '' || ((templateId?.length >= 12 && templateId?.length <= 30) && validateOnlyNumbers(templateId))) ? "default" : "error"
    }

    const getURLShortenerFooter = (): React.ReactNode => {
        return (
            <div className={Styles.flexEnd}>
                <Button type="tertiary" onClick={() => { setUrlShortenerText(''); setShowSideModal(false) }}>
                    {t('mainCancel')}
                </Button>
                <Button type="primary" onClick={() => handleURLShortener()} disabled={!isValidUrl()}>
                    {t('mainSave')}
                </Button>
            </div>
        );
    };

    const callback = (response: any, flag: boolean) => {
        if (flag && isEmpty(response.error)) {
            Toast(response.message, 'success');
            onLoad();
            onClose();
        } else if (!isEmpty(response.error)) {
            Object.keys(response.error).forEach((key: any) => {
                Toast(response.error[key], 'error');
            });
        } else {
            Toast(response.message, 'error');
        }
    }

    const urlShortenerCallback = (response: any, flag: boolean) => {
        if (flag && response.data) {
            Toast(response.message, 'success');
            // setShortenedUrl(response.data?.shortLink || '');
            setShowSideModal(false);
            let content = textContent;
            content = (content.trim() + ' ' + response.data.shortLink).trim();
            setTextContent(content);
            setUrlShortenerText('');

        } else {
            Toast(response?.message, 'error');
        }
    }

    const isValidUrl = () => {
        return validateURL('url', urlShortenerText)
    }

    const senderIdOption = (): OptionType[] => {
        let options: OptionType[] = [];
        Object.keys(data.smsTemplatesData.sender_array).forEach((key: string) => {
            options.push({
                key: key?.replace(/ /g, "\u00A0"),
                value: data.smsTemplatesData.sender_array[key]?.replace(/ /g, "\u00A0")
            })
        })
        return options;
    }

    const purposeOption = (): OptionType[] => {
        let options: OptionType[] = [];
        Object.keys(data.smsTemplatesData.routes).forEach((key: string) => {
            options.push({
                key: key?.replace(/ /g, "\u00A0"),
                value: data.smsTemplatesData.routes[key]?.replace(/ /g, "\u00A0")
            })
        })
        return options;
    }

    const handleTemplateEdit = () => {
        if (textContent === '') {
            Toast("Template content is required", "error");
            return;
        }
        if (templateIdStatus() === "error") {
            Toast("Numeric Template ID is allowed and it can only contain a minimum of 12 digits and maximum of 30 digits ", "error");
            return;
        }
        const { status } = templateViewDetails.templates[0];
        const formatEditPayload = {
            "activity_log_action": "Edited",
            "activity_log_object": "SMS TEMPLATE",
            "activity_log_object_value": title,
            "template_ids": [params.id.toString()],
            data: {
                sender_id: senderId ? senderId.key : undefined,
                template_id: templateId,
                content: (status.id).toString() === "4" ? textContent : undefined
            }
        }
        onSave(formatEditPayload, callback);
    }

    const handleURLShortener = () => {
        const formatPayload = {
            data: [
                {
                    url: urlShortenerText,
                    title: "1",
                    status: 1,
                    is_advanced: 1,
                }
            ]
        }
        onShortenUrl(formatPayload, urlShortenerCallback);
    }

    const handleAttachFile = (file: any) => {
        const formData = new FormData();
        formData.append('is_advanced', "1");
        formData.append('document_ids', file);
        onFileShortener(formData, fileShortenerCallback)
    }

    const fileShortenerCallback = (response: any, flag: boolean) => {
        if (flag && !isEmpty(response.data)) {
            Toast(response.message, 'success');
            const fileUrl = response.data[0].shortLink
            let content = textContent;
            content = (content.trim() + ' ' + fileUrl).trim();
            setTextContent(content);
        } else {
            Toast(response.message, 'error');
        }
    }

    const getPurposeValue = () => {
        if (purpose) {
            return purpose.value || purpose;
        }
        return undefined;
    }

    const getSenderIdValue = () => {
        if (senderId) {
            return senderId.value?.replace(/ /g, "\u00A0") || senderId?.replace(/ /g, "\u00A0");
        }
        return undefined;
    }

    const getBody = () => {
        const { status } = templateViewDetails.templates[0];
        return (
            <div className={Styles.container}>
                <Input
                    bordered={true}
                    placeholder={t('mainTitle')}
                    label={t('mainTitle')}
                    disabled
                    value={title}
                    onChange={(e: any) => setTitle(e.target.value)}
                    showBottomLabelSpace={false}
                    className={Styles.inputField}
                />
                <Select
                    label={t('assetsWidgetPurpose')}
                    placeholder={t('assetsWidgetPurpose')}
                    disabled
                    showBottomLabelSpace={false}
                    options={purposeOption()}
                    value={getPurposeValue()}
                    onChange={(val: any, key: any) => setPurpose(key)}
                    className={Styles.inputField}
                    showSearch
                >
                </Select>
                {
                    isIndiaUser &&
                    <Select
                        label={t('verifySenderID')}
                        placeholder={t('verifySenderID')}
                        options={senderIdOption()}
                        value={getSenderIdValue()}
                        onChange={(val: any, key: any) => setSenderId(key)}
                        className={Styles.inputField}
                        showBottomLabelSpace={false}
                        showSearch
                    >
                    </Select>}
                {
                    isIndiaUser &&
                    <Input
                        bordered={true}
                        placeholder={t('verifyTemplateId')}
                        label={t('verifyTemplateId')}
                        value={templateId || ''}
                        onChange={(e: any) => setTemplateId(e.target.value)}
                        className={Styles.inputField}
                        showBottomLabelSpace={false}
                        bottomLabelType={templateIdStatus()}
                    />}
                <div className={Styles.textBox}>
                    <TextArea
                        placeholder={t('KLR00104')}
                        label={t('KLR00104')}
                        style={{ height: '8rem', paddingBottom: '3rem' }}
                        disabled={(status.id).toString() !== "4"}
                        value={textContent}
                        onChange={(e) => setTextContent(e.target.value)}
                        showDetailsFooter={true}
                        showMessageCount={true}
                        showAttachmentOption={true}
                        showInsertLinkOption={true}
                        characterLimit={4000}
                        onInsertLink={() => {
                            (status.id).toString() === "4" ? setShowSideModal(true) : setShowSideModal(false)
                        }}
                        onAttach={(file: any) => handleAttachFile(file)}
                        textLength={textareaCharCount}
                        msgCountProp={messageUnitsCount}
                        getText={(text: string) => {
                            // const { count, units } = getcharcount(textContent);
                            // setTextareaCharCount(count);
                            // setMessageUnitsCount(units);
                        }}
                    />
                </div>
                <Slider
                    containerId="root-modal"
                    visibility={showSideModal}
                    onClose={() => setShowSideModal(false)}
                    title={t('KLR00105')}
                    footer={getURLShortenerFooter()}
                >
                    <div className={Styles.container}>
                        <Input
                            label={t('KLR00106')}
                            placeholder={t('KLR00106')}
                            value={urlShortenerText}
                            onChange={(e: any) => setUrlShortenerText(e.target.value)}
                            bottomLabelType={isValidUrl() ? "default" : "error"}
                        />
                    </div>
                </Slider>
            </div>
        )
    }

    return (
        <Slider
            containerId="root-modal"
            visibility={true}
            onClose={onClose}
            footer={getMainFooter()}
            title={t('KLR00108')}
        >
            {getBody()}
        </Slider>
    );

};


export default TemplateEditForm;
